export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-path-f9af636a7ed5c5c1494fc71dddcc7d78.svg";